import { render } from "./LogoToFooter.vue?vue&type=template&id=370ed132"
import script from "./LogoToFooter.vue?vue&type=script&lang=js"
export * from "./LogoToFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__